import { Directive } from '@angular/core';

@Directive({
    selector: 'dshBaseDialogActions, [dshBaseDialogActions]',
})
export class BaseDialogActionsDirective {}
